export enum TipoPrestamoEnum {
    CON_CUOTAS,
    ANTICIPADO,
    VENCIDO,
}